import { BaseResource } from "./base.resource";

export class ChangeLog extends BaseResource {
  entity: string;
  key: string;
  property: string;
  oldValue: any;
  newValue: any;
  changedBy: string;
  changedOn: Date;

  constructor(options?: any) {
    super(options);
  }
}
